<template>
  <div id="applied">
    <navbar clickable="true"></navbar>
    <div id="sections-area">
      <section id="hero-section">
        <svg class="party" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;;display:block;z-index:-1;position:absolute" preserveAspectRatio="xMidYMid" viewBox="0 0 1920 969">
          <g transform="translate(960,484.5) scale(1,1) translate(-960,-484.5)">
            <g transform="translate(0 838.790940284774)"><g transform="translate(299.06824349805987 0)">
              <g class="ld ld-fall" style="animation-delay:NaNs;animation-duration:4s">
                <rect x="-5.4502072906537276" y="-3.2241526044151723" width="10.900414581307455" height="6.4483052088303445" style="transform:scale(1.8805918567902973)" fill="#532788"></rect>
              </g></g><g transform="translate(718.1990114999495 0)">
              <g class="ld ld-fall" style="animation-delay:-0.677839993252265s;animation-duration:4s">
                <rect x="-3.7211330195010732" y="-5.391514601646075" width="7.4422660390021464" height="10.78302920329215" style="transform:scale(2.6888714821198367)" fill="#366fa9"></rect>
              </g></g><g transform="translate(595.9398852852521 0)">
              <g class="ld ld-fall" style="animation-delay:-1.0591843330421922s;animation-duration:4s">
                <rect x="-4.924878999749524" y="-5.37624453678729" width="9.849757999499047" height="10.75248907357458" style="transform:scale(1.5300086562751947)" fill="#30aeb3"></rect>
              </g></g><g transform="translate(549.8978118517356 0)">
              <g class="ld ld-fall" style="animation-delay:-1.6733509291517423s;animation-duration:2s">
                <rect x="-5.120062264281759" y="-4.559910912377425" width="10.240124528563518" height="9.11982182475485" style="transform:scale(3.1360704606610246)" fill="#c83a27"></rect>
              </g></g><g transform="translate(132.34777145804856 0)">
              <g class="ld ld-fall" style="animation-delay:-1.6032787949711231s;animation-duration:2s">
                <rect x="-3.048700043294097" y="-5.724579973000816" width="6.097400086588194" height="11.449159946001632" style="transform:scale(2.6012583679366106)" fill="#c83a27"></rect>
              </g></g><g transform="translate(83.91574080128791 0)">
              <g class="ld ld-fall" style="animation-delay:-1.0210421824370806s;animation-duration:4s">
                <rect x="-3.37110830236825" y="-4.595457859254078" width="6.7422166047365" height="9.190915718508156" style="transform:scale(2.9385526624301797)" fill="#14d1bd"></rect>
              </g></g><g transform="translate(1764.7147635958934 0)">
              <g class="ld ld-fall" style="animation-delay:-3.157754217597798s;animation-duration:4s">
                <rect x="-4.432924083581787" y="-4.625279284889955" width="8.865848167163573" height="9.25055856977991" style="transform:scale(3.1407511559743115)" fill="#c83a27"></rect>
              </g></g><g transform="translate(1910.2704826787935 0)">
              <g class="ld ld-fall" style="animation-delay:-3.290957480923753s;animation-duration:4s">
                <rect x="-5.854869290987189" y="-3.6978921371945397" width="11.709738581974378" height="7.395784274389079" style="transform:scale(3.4468307952687653)" fill="#c83a27"></rect>
              </g></g><g transform="translate(1828.8730762135128 0)">
              <g class="ld ld-fall" style="animation-delay:-3.131982274736197s;animation-duration:2s">
                <rect x="-5.034471541368394" y="-4.079974674018069" width="10.068943082736787" height="8.159949348036138" style="transform:scale(2.378372551746545)" fill="#fefefe"></rect>
              </g></g><g transform="translate(682.3642754013458 0)">
              <g class="ld ld-fall" style="animation-delay:-1.4565419833123796s;animation-duration:2s">
                <rect x="-4.392877185135031" y="-4.77645355555183" width="8.785754370270062" height="9.55290711110366" style="transform:scale(3.375854985150244)" fill="#fefefe"></rect>
              </g></g><g transform="translate(1018.1159900005024 0)">
              <g class="ld ld-fall" style="animation-delay:-0.33674470699052206s;animation-duration:2s">
                <rect x="-5.345231397356617" y="-3.672393309894562" width="10.690462794713234" height="7.344786619789124" style="transform:scale(2.9497855387819705)" fill="#c83a27"></rect>
              </g></g><g transform="translate(339.4364354818086 0)">
              <g class="ld ld-fall" style="animation-delay:-0.7415464507574536s;animation-duration:4s">
                <rect x="-4.711706723621279" y="-5.860062091113398" width="9.423413447242558" height="11.720124182226796" style="transform:scale(2.6599190108527946)" fill="#366fa9"></rect>
              </g></g><g transform="translate(618.9583905309153 0)">
              <g class="ld ld-fall" style="animation-delay:-2.1989349866092907s;animation-duration:4s">
                <rect x="-3.746414852707554" y="-3.21876863909164" width="7.492829705415108" height="6.43753727818328" style="transform:scale(2.450224240057091)" fill="#366fa9"></rect>
              </g></g><g transform="translate(1782.9297463411203 0)">
              <g class="ld ld-fall" style="animation-delay:-3.3207226232822062s;animation-duration:4s">
                <rect x="-4.601346584637512" y="-4.073538111374056" width="9.202693169275024" height="8.147076222748112" style="transform:scale(2.1403270985771865)" fill="#366fa9"></rect>
              </g></g><g transform="translate(383.1695592214287 0)">
              <g class="ld ld-fall" style="animation-delay:-3.9374452358128416s;animation-duration:4s">
                <rect x="-3.916217684733142" y="-4.210113646033524" width="7.832435369466284" height="8.420227292067048" style="transform:scale(2.9535921992613954)" fill="#fefefe"></rect>
              </g></g><g transform="translate(1847.725070998445 0)">
              <g class="ld ld-fall" style="animation-delay:-3.3590319220526297s;animation-duration:2s">
                <rect x="-3.977459267201921" y="-3.1235485507092466" width="7.954918534403842" height="6.247097101418493" style="transform:scale(2.2430813377704766)" fill="#14d1bd"></rect>
              </g></g><g transform="translate(1717.5414124902895 0)">
              <g class="ld ld-fall" style="animation-delay:-0.8760297617069948s;animation-duration:2s">
                <rect x="-4.755498020480631" y="-3.1631798184280324" width="9.510996040961261" height="6.326359636856065" style="transform:scale(2.2498640491176087)" fill="#532788"></rect>
              </g></g><g transform="translate(1037.7011248682456 0)">
              <g class="ld ld-fall" style="animation-delay:-0.5773940374123856s;animation-duration:4s">
                <rect x="-3.4465436850760267" y="-5.391612727414335" width="6.893087370152053" height="10.78322545482867" style="transform:scale(2.7116824249657636)" fill="#751da7"></rect>
              </g></g><g transform="translate(474.3257856693144 0)">
              <g class="ld ld-fall" style="animation-delay:-1.3416058629384855s;animation-duration:2s">
                <rect x="-4.100417576853397" y="-3.046403530329889" width="8.200835153706795" height="6.092807060659778" style="transform:scale(1.9767867057388697)" fill="#fefefe"></rect>
              </g></g><g transform="translate(484.77771529911206 0)">
              <g class="ld ld-fall" style="animation-delay:-0.8255453142379618s;animation-duration:4s">
                <rect x="-3.744007503746709" y="-4.228125544918341" width="7.488015007493418" height="8.456251089836682" style="transform:scale(1.5226643880281645)" fill="#fefefe"></rect>
              </g></g><g transform="translate(602.2532804210856 0)">
              <g class="ld ld-fall" style="animation-delay:-3.331866850015472s;animation-duration:4s">
                <rect x="-3.3580152237820715" y="-3.632689289055814" width="6.716030447564143" height="7.265378578111628" style="transform:scale(3.208446012693323)" fill="#fefefe"></rect>
              </g></g><g transform="translate(479.94201725590784 0)">
              <g class="ld ld-fall" style="animation-delay:-0.6819915207492251s;animation-duration:4s">
                <rect x="-3.7502289982534567" y="-4.635770524727144" width="7.500457996506913" height="9.271541049454289" style="transform:scale(2.0507127176291475)" fill="#c83a27"></rect>
              </g></g><g transform="translate(358.3678429355483 0)">
              <g class="ld ld-fall" style="animation-delay:-3.0521038045671025s;animation-duration:4s">
                <rect x="-3.076697144713918" y="-5.840158982850242" width="6.153394289427836" height="11.680317965700484" style="transform:scale(2.813297596574917)" fill="#366fa9"></rect>
              </g></g><g transform="translate(151.50499673536245 0)">
              <g class="ld ld-fall" style="animation-delay:-3.7350657345301244s;animation-duration:4s">
                <rect x="-5.993483160798848" y="-5.561995388567664" width="11.986966321597697" height="11.123990777135328" style="transform:scale(2.803290489348631)" fill="#30aeb3"></rect>
              </g></g><g transform="translate(1866.2436431744184 0)">
              <g class="ld ld-fall" style="animation-delay:-0.3054434278540157s;animation-duration:4s">
                <rect x="-5.850897730384758" y="-5.489110700859982" width="11.701795460769516" height="10.978221401719964" style="transform:scale(2.595888774288065)" fill="#366fa9"></rect>
              </g></g></g>
            <g transform="translate(0 -130.20905971522598)"><g transform="translate(299.06824349805987 0)">
              <g class="ld ld-fall" style="animation-delay:NaNs;animation-duration:4s">
                <rect x="-5.4502072906537276" y="-3.2241526044151723" width="10.900414581307455" height="6.4483052088303445" style="transform:scale(1.8805918567902973)" fill="#532788"></rect>
              </g></g><g transform="translate(718.1990114999495 0)">
              <g class="ld ld-fall" style="animation-delay:-0.677839993252265s;animation-duration:4s">
                <rect x="-3.7211330195010732" y="-5.391514601646075" width="7.4422660390021464" height="10.78302920329215" style="transform:scale(2.6888714821198367)" fill="#366fa9"></rect>
              </g></g><g transform="translate(595.9398852852521 0)">
              <g class="ld ld-fall" style="animation-delay:-1.0591843330421922s;animation-duration:4s">
                <rect x="-4.924878999749524" y="-5.37624453678729" width="9.849757999499047" height="10.75248907357458" style="transform:scale(1.5300086562751947)" fill="#30aeb3"></rect>
              </g></g><g transform="translate(549.8978118517356 0)">
              <g class="ld ld-fall" style="animation-delay:-1.6733509291517423s;animation-duration:2s">
                <rect x="-5.120062264281759" y="-4.559910912377425" width="10.240124528563518" height="9.11982182475485" style="transform:scale(3.1360704606610246)" fill="#c83a27"></rect>
              </g></g><g transform="translate(132.34777145804856 0)">
              <g class="ld ld-fall" style="animation-delay:-1.6032787949711231s;animation-duration:2s">
                <rect x="-3.048700043294097" y="-5.724579973000816" width="6.097400086588194" height="11.449159946001632" style="transform:scale(2.6012583679366106)" fill="#c83a27"></rect>
              </g></g><g transform="translate(83.91574080128791 0)">
              <g class="ld ld-fall" style="animation-delay:-1.0210421824370806s;animation-duration:4s">
                <rect x="-3.37110830236825" y="-4.595457859254078" width="6.7422166047365" height="9.190915718508156" style="transform:scale(2.9385526624301797)" fill="#14d1bd"></rect>
              </g></g><g transform="translate(1764.7147635958934 0)">
              <g class="ld ld-fall" style="animation-delay:-3.157754217597798s;animation-duration:4s">
                <rect x="-4.432924083581787" y="-4.625279284889955" width="8.865848167163573" height="9.25055856977991" style="transform:scale(3.1407511559743115)" fill="#c83a27"></rect>
              </g></g><g transform="translate(1910.2704826787935 0)">
              <g class="ld ld-fall" style="animation-delay:-3.290957480923753s;animation-duration:4s">
                <rect x="-5.854869290987189" y="-3.6978921371945397" width="11.709738581974378" height="7.395784274389079" style="transform:scale(3.4468307952687653)" fill="#c83a27"></rect>
              </g></g><g transform="translate(1828.8730762135128 0)">
              <g class="ld ld-fall" style="animation-delay:-3.131982274736197s;animation-duration:2s">
                <rect x="-5.034471541368394" y="-4.079974674018069" width="10.068943082736787" height="8.159949348036138" style="transform:scale(2.378372551746545)" fill="#fefefe"></rect>
              </g></g><g transform="translate(682.3642754013458 0)">
              <g class="ld ld-fall" style="animation-delay:-1.4565419833123796s;animation-duration:2s">
                <rect x="-4.392877185135031" y="-4.77645355555183" width="8.785754370270062" height="9.55290711110366" style="transform:scale(3.375854985150244)" fill="#fefefe"></rect>
              </g></g><g transform="translate(1018.1159900005024 0)">
              <g class="ld ld-fall" style="animation-delay:-0.33674470699052206s;animation-duration:2s">
                <rect x="-5.345231397356617" y="-3.672393309894562" width="10.690462794713234" height="7.344786619789124" style="transform:scale(2.9497855387819705)" fill="#c83a27"></rect>
              </g></g><g transform="translate(339.4364354818086 0)">
              <g class="ld ld-fall" style="animation-delay:-0.7415464507574536s;animation-duration:4s">
                <rect x="-4.711706723621279" y="-5.860062091113398" width="9.423413447242558" height="11.720124182226796" style="transform:scale(2.6599190108527946)" fill="#366fa9"></rect>
              </g></g><g transform="translate(618.9583905309153 0)">
              <g class="ld ld-fall" style="animation-delay:-2.1989349866092907s;animation-duration:4s">
                <rect x="-3.746414852707554" y="-3.21876863909164" width="7.492829705415108" height="6.43753727818328" style="transform:scale(2.450224240057091)" fill="#366fa9"></rect>
              </g></g><g transform="translate(1782.9297463411203 0)">
              <g class="ld ld-fall" style="animation-delay:-3.3207226232822062s;animation-duration:4s">
                <rect x="-4.601346584637512" y="-4.073538111374056" width="9.202693169275024" height="8.147076222748112" style="transform:scale(2.1403270985771865)" fill="#366fa9"></rect>
              </g></g><g transform="translate(383.1695592214287 0)">
              <g class="ld ld-fall" style="animation-delay:-3.9374452358128416s;animation-duration:4s">
                <rect x="-3.916217684733142" y="-4.210113646033524" width="7.832435369466284" height="8.420227292067048" style="transform:scale(2.9535921992613954)" fill="#fefefe"></rect>
              </g></g><g transform="translate(1847.725070998445 0)">
              <g class="ld ld-fall" style="animation-delay:-3.3590319220526297s;animation-duration:2s">
                <rect x="-3.977459267201921" y="-3.1235485507092466" width="7.954918534403842" height="6.247097101418493" style="transform:scale(2.2430813377704766)" fill="#14d1bd"></rect>
              </g></g><g transform="translate(1717.5414124902895 0)">
              <g class="ld ld-fall" style="animation-delay:-0.8760297617069948s;animation-duration:2s">
                <rect x="-4.755498020480631" y="-3.1631798184280324" width="9.510996040961261" height="6.326359636856065" style="transform:scale(2.2498640491176087)" fill="#532788"></rect>
              </g></g><g transform="translate(1037.7011248682456 0)">
              <g class="ld ld-fall" style="animation-delay:-0.5773940374123856s;animation-duration:4s">
                <rect x="-3.4465436850760267" y="-5.391612727414335" width="6.893087370152053" height="10.78322545482867" style="transform:scale(2.7116824249657636)" fill="#751da7"></rect>
              </g></g><g transform="translate(474.3257856693144 0)">
              <g class="ld ld-fall" style="animation-delay:-1.3416058629384855s;animation-duration:2s">
                <rect x="-4.100417576853397" y="-3.046403530329889" width="8.200835153706795" height="6.092807060659778" style="transform:scale(1.9767867057388697)" fill="#fefefe"></rect>
              </g></g><g transform="translate(484.77771529911206 0)">
              <g class="ld ld-fall" style="animation-delay:-0.8255453142379618s;animation-duration:4s">
                <rect x="-3.744007503746709" y="-4.228125544918341" width="7.488015007493418" height="8.456251089836682" style="transform:scale(1.5226643880281645)" fill="#fefefe"></rect>
              </g></g><g transform="translate(602.2532804210856 0)">
              <g class="ld ld-fall" style="animation-delay:-3.331866850015472s;animation-duration:4s">
                <rect x="-3.3580152237820715" y="-3.632689289055814" width="6.716030447564143" height="7.265378578111628" style="transform:scale(3.208446012693323)" fill="#fefefe"></rect>
              </g></g><g transform="translate(479.94201725590784 0)">
              <g class="ld ld-fall" style="animation-delay:-0.6819915207492251s;animation-duration:4s">
                <rect x="-3.7502289982534567" y="-4.635770524727144" width="7.500457996506913" height="9.271541049454289" style="transform:scale(2.0507127176291475)" fill="#c83a27"></rect>
              </g></g><g transform="translate(358.3678429355483 0)">
              <g class="ld ld-fall" style="animation-delay:-3.0521038045671025s;animation-duration:4s">
                <rect x="-3.076697144713918" y="-5.840158982850242" width="6.153394289427836" height="11.680317965700484" style="transform:scale(2.813297596574917)" fill="#366fa9"></rect>
              </g></g><g transform="translate(151.50499673536245 0)">
              <g class="ld ld-fall" style="animation-delay:-3.7350657345301244s;animation-duration:4s">
                <rect x="-5.993483160798848" y="-5.561995388567664" width="11.986966321597697" height="11.123990777135328" style="transform:scale(2.803290489348631)" fill="#30aeb3"></rect>
              </g></g><g transform="translate(1866.2436431744184 0)">
              <g class="ld ld-fall" style="animation-delay:-0.3054434278540157s;animation-duration:4s">
                <rect x="-5.850897730384758" y="-5.489110700859982" width="11.701795460769516" height="10.978221401719964" style="transform:scale(2.595888774288065)" fill="#366fa9"></rect>
              </g></g></g></g>
        </svg>
        <div class="container-fluid mt-5">
          <div class="row justify-content-center mb-5">
            <div class="col-lg-10 col-sm-12">
              <div class="row justify-content-center">
                <div class="col-12 col-sm-12 col-md-12 order-lg-1 order-md-1">
                  <div v-if="!loading && !problem" class="intro-message pt-5 mt-5">
                    <h1 class="h1-title w-100 d-block
                    text-left">Hey {{ name }},<br>
                      {{ app }} IS READY! 🥳</h1>
                    <p>LinkedIn’s co-founder Reid Hoffman once said: “Starting a start-up is jumping off a cliff and assembling the airplane on the way down.” - If that’s the case, a tech team with the right SPIRITT is essential. We are here. </p>
                    <p></p>
                    <p class="no-cv mt-5">** YES, the screenshots below are from your app</p>
                    <div class="screenshots my-md-4 d-flex justify-content-center W-100">
                      <div class="row mb-5 mt-4 justify-content-center">
                        <div v-for="(img, i) in media" :key="i" :class="`showcase-container col-12 ${media.length > 1 ? 'col-md-6' : 'col-md-8'} mb-3`" data-aos="fade-right" data-aos-duration="800">
                          <img class="w-100 showcase-img" alt="SPIRITT showcase" :src="img">
                        </div>
                      </div>
                    </div>
                    <div class="instructions my-4 d-flex justify-content-center W-100">
                      <div class="row w-100 mx-auto mb-5 mt-4 justify-content-center">
                       <h2 class="medium-title text-center mb-3 w-100 d-block">Instructions:</h2>
                        <div v-for="(section, i) in instructions" :key="i" class="row w-100 mx-auto px-0 px-md-4 mb-5 justify-content-center" data-aos="fade-up" data-aos-duration="800">
                          <div class="col-auto mb-4">
                            <img :src="section.img" alt="fast applications and websites" class="instruction-icon align-self-start">
                          </div>
                          <div class="col mb-4 pt-1 pt-md-3">
                            <p class="instruction-text text-left">{{ section.text }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="insta-offer my-5 d-flex justify-content-center W-100">
                      <div class="insta-frame position-relative pt-5 col-10 row w-100 mx-auto mb-5 mt-4 justify-content-center">
                        <div class="row w-100 mx-auto px-4 mb-5" data-aos="fade-up" data-aos-duration="800">
                          <h2 class="medium-title text-center mb-3 w-100 d-block">Ohh…. And, we have an offer🤑🤫</h2>
                          <p class="text-left d-block w-100">1) Upload a selfie with the screenshots below(👇) to your IG</p>
                          <p class="text-left d-block w-100">2) Tag us (@spiritt.io)</p>
                          <p class="text-left d-block w-100">3) Add your honest feeling at the moment on the caption</p>
                          <p class="text-left d-block w-100">4) Get 125$ credit for your next month</p>
                        </div>
                      </div>
                    </div>
                  </div >
                  <h1 class="text-center loading" v-if="loading && !problem">loading...</h1>
                  <h1 class="text-center loading" v-if="problem">Page Does Not Exist or Expired🤕</h1>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!loading && !problem" class="pt-5 mt-5">
            <div class="row flex-nowrap justify-content-center align-items-center">
              <div class="col-auto">
                <img src="/img/why-us/spiritt-icon.svg" alt="SPIRITT An all-in-one boutique app for high-standard entrepreneurs" class="img-fluid align-self-center spiritt-icon">
              </div>
              <div class="col-auto align-items-center"><h2 class="medium-title text-center">Something Big Is Coming </h2></div>
              <div class="col-auto">
                <img src="/img/why-us/spiritt-icon.svg" alt="SPIRITT An all-in-one boutique app for high-standard entrepreneurs" class="img-fluid align-self-center spiritt-icon2">
              </div>
            </div>
            <div class="screenshots px-3 my-md-4 d-flex justify-content-center W-100">
              <div class="row mb-5 mt-4 justify-content-center">
                <div v-for="(img, i) in media" :key="i" :class="`showcase-container col-12 ${media.length > 1 ? 'col-md-6' : 'col-md-8'} mb-3`" >
                  <img class="w-100 showcase-img" alt="SPIRITT showcase" :src="img">
                </div>
              </div>
            </div>
            <div class="row mb-5 pb-5 d-none d-md-flex">
              <div class="col-12 mb-5 mx-auto jobs">
                <div class="col-3 col-md-2 h-100 align-items-center justify-content-end d-none d-md-flex">
                  <img src="/img/why-choose-us/jobs.png" srcset="/img/why-choose-us/jobs@2x.png 2x, /img/why-choose-us/jobs@3x.png 3x" alt="spiritt apps" class="jobs-img img-fluid align-self-center h-75">
                </div>
                <div class="col-9 col-md-7 align-items-center d-none d-md-flex">
                  <p class="h5 text-left">"The People Who Are Crazy Enough to Think They Can Change the World Are the Ones Who Do." - S. Jobs</p>
                </div>
              </div>
            </div>
            <div class="w-100 mx-auto mb-5 pt-5">
              <h2 class="medium-title mb-5 pt-5 text-center mb-3 w-100 d-block">👇Ready?👇</h2>
              <div class="get-app-btn my-md-3 mb-5 W-100">
                <div class="row my-md-5 px-2">
                  <div class="col-12 mt-3 get-app-btn-container">
                    <a @click="onButtonClick" target="_blank" class="btn btn-hero btn-hero-primary justify-content-center align-items-center d-flex text-center">Get Your App</a>
                    <h2 class="medium-title mt-5 pt-5 text-center mb-3 w-100 d-block">👆Go👆</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div v-if="!loading && !problem" class="text-center my-2 footer-text">
        <a target="_blank" rel="nofollow" href="/docs/terms-of-use.pdf">Terms & Conditions</a>
        ·
        <a target="_blank" rel="nofollow" href="/docs/privacy-policy.pdf">Privacy Policy</a>
        ·
        <a target="_blank" href="/#contact">Contact Us</a>
        ·
        <a target="_blank" rel="nofollow" href="/join-the-team">Apply For a Job</a>
        ·
        <a target="_blank" href="https://www.facebook.com/spiritt.apps/" rel="noopener" >Facebook</a>
        ·
        <a target="_blank" href="https://www.instagram.com/spiritt.io/" rel="noopener" >Instagram</a>
      </div>
    </div>
    <img class="background-fixed-img" src="/img/startup-bg.jpg" alt="SPIRITT background">
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Navbar from './components/Navbar.vue';
import axios from 'axios'

export default {
  name: 'get-your-app',
  props: ['id'],
  computed: {
    ...mapState('layout', {
      language: state => state.language,
    }),
    ...mapGetters({
      mobile: 'layout/mobile',
      modal: 'layout/modal',
      isScrolled: 'layout/isScrolled',
      isMvpModalOpen: 'layout/isMvpModalOpen',
    }),
  },
  data() {
    return {
      name: '',
      lastName: '',
      app: 'your app',
      phone: '',
      email: '',
      media: null,
      loading: true,
      problem: false,
      status: '',
      app_link: '',
      instructions: [
        {img: '/img/get-your-app/Wave.svg', text: 'WELCOME to your app; This is a starting point of a long and incredible journey of making the world a better place! Remember, it is going to be hard, but the mission is worth it. KEEP GOING '},
        {img: '/img/get-your-app/7days.svg', text: 'Notice: You have 7 days to test your product for free before you decide to pay. In order to provide you with the optimal test experience, in the next 7 days, when people make payments in your app, they won\'t be charged. Also, we filled your app with dummy data. At the end of the 7 days, payments will start to work, and all the data from the test period will be deleted. '},
        {img: '/img/get-your-app/admin.svg', text: 'In order to see your app as an admin (admin can edit everything and see everything) login with the email&pass that you got in the last message'},
        {img: '/img/get-your-app/tab.svg', text: 'Once you are logged in as an Admin, you can see a tab on the right side of your app, use it to request changes, requests, or report bugs; Notice: you can start sending requests right away.'},
        {img: '/img/get-your-app/starting-point.svg', text: 'The product you see is a *starting point*. We do our best to fit your envisioned product, but there is always a tiny gap (Usually 95% fit), and it is fine; start-up is a journey. The solution for closing this gap is "SPIRITT requests" (you\'re gonna see it when you sign in as an admin). It\'s much more effective to work on that 5% when your app is in front of you. So, let\'s make it happen; we"re looking forward to your requests.🤩'},
        {img: '/img/get-your-app/users.svg', text: 'We recommend you to open more than one user: the reason is your app looks very different between an admin user and a regular user, and we think its essential you could look at it from your customer’s eyes'},
        {img: '/img/get-your-app/cross-platforms.svg', text: 'We highly recommend looking at your app from a desktop computer as well as a mobile phone because both are gorgeous but different! '},
      ],
    }
  },
  components: {
    'navbar': Navbar,
  },
  methods: {
    ...mapActions({
      updateModalTitle: 'layout/updateModalTitle',
      updateModalVisibility: 'layout/updateModalVisibility',
      updateModalContent: 'layout/updateModalContent',
      updateIsScrolled: 'layout/updateIsScrolled',
      updateMvpModalVisibility: 'layout/updateMvpModalVisibility',
    }),
    onButtonClick() {
      this.loading = true;
      axios.post('https://hook.integromat.com/v6jp0u1jc78rx8ams7exaa8vuibyi91e',{
        email: this.email,
        phone: this.phone,
        first_name: this.name,
        last_name: this.lastName,
        id: this.id,
        payed: !!(this.status === 'Payed'),
      }).then(() => {
        this.loading = false;
        window.location.href = this.app_link; //this.status === 'Payed'? this.app_link : `https://get.spiritt.app/${this.id}/3932138`;
      }).catch(() => {
        this.problem = true;
        this.loading = false;
      });

    },
    handleScroll () {
      return this.isScrolled && window.scrollY ? null : this.updateIsScrolled({
        payload: {
          scrolled: window.scrollY,
        },
      });
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    axios.post('https://hook.integromat.com/7qr316vm2nv4tq5swwxrd9fk7hhddvzl',{
      id: this.id
    }).then((response) => {
      if (response.data.length < 3 ){
        this.problem = true;
        this.loading = false;
      } else {
        this.name = response.data[0].text;
        this.lastName = response.data[1].text;
        this.app = response.data[2].text;
        this.phone = response.data[3].text;
        this.email = response.data[4].text;
        this.media = response.data[5].text ? response.data[5].text.split(',') : [`https://delivery-page-assets.s3.eu-west-1.amazonaws.com/${this.id}.png`];
        this.app_link = response.data[6].text;
        this.status = response.data[7].text;
        this.loading = false;
      }
    }).catch(() => {
      this.problem = true;
      this.loading = false;
    });
  },
}
</script>
<style lang="css" scoped>
@import url('https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700&display=swap');
#applied {
  font-family: Josefin Sans, sans-serif;
  font-size: 1.125rem;
  position: relative;
  overflow: hidden;
  scroll-behavior: smooth;
  display: block;
}
.background-fixed-img{
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  transition: opacity 1s;
  background-attachment: fixed;
  object-fit: cover;
  z-index: -1;
}
.showcase-img{
  border-radius: 1rem;
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select-: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  pointer-events: none;
}

.instruction-text{
 font-size: 22px;
  font-weight: normal;
}

.insta-frame{
  border-radius: 20px;
  background: #000;
}

.jobs-img{
  object-fit: cover;
}

.insta-text{
  white-space: break-spaces;
}
.spiritt-icon {
  object-fit: contain;
  height: 80px;
  -webkit-animation: cog 7s infinite;
  -moz-animation: cog 7s infinite;
  -ms-animation: cog 7s infinite;
  animation: cog 7s infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-timing-function: linear;
  -ms-animation-timing-function: linear;
  animation-timing-function: linear
}
@keyframes cog {
  100%{
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.spiritt-icon2 {
  object-fit: contain;
  height: 80px;
  -webkit-animation: cog2 7s infinite;
  -moz-animation: cog2 7s infinite;
  -ms-animation: cog2 7s infinite;
  animation: cog2 7s infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-timing-function: linear;
  -ms-animation-timing-function: linear;
  animation-timing-function: linear
}
@keyframes cog2 {
  0%{
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  100%{
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

.insta-frame:before{
  border-radius: 20px;
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  bottom: -4px;
  right: -4px;
  background: linear-gradient(60deg, #405DE6, #833AB4, #E1306C, #F56040, #FFDC80);
  z-index: -1;
  animation: animatedgradient 4s ease alternate infinite;
  background-size: 300% 300%;
}
@keyframes animatedgradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.no-cv{
  color: #14D1BD !important;;
}
.text-holder{
  background-color: rgba(256, 256, 256, 0.2);
  border-radius: 22px;
  border: 1px solid rgba(256, 256, 256, 0.6);
  padding: 15px 20px;
}

.jobs {
  background-image: linear-gradient(95deg, rgba(255, 255, 255, 0.15) 1%, rgba(255, 255, 255, 0) 100%);
  display: flex;
  min-height: 240px;
}

@media (max-width: 767px) and (min-width: 320px){
  .background-fixed-img {
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 1;
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    transition: opacity 1s;
    z-index: -1;
  }
}
.loading{
  margin-top: 30vh;
 font-size: 70px;
}
.instruction-icon{
  height: 110px;
}

.party{
  position: fixed !important;
  z-index: -1;
  top: -50px;
  bottom: -50px;
  right: -50px;
  left: -50px;
  opacity: 0.6;
  min-height: 100vh;
  padding: 0;
}

#hero-section {
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  content: "";
  z-index: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  position: relative;
  /* background-image: url("/img/why-choose-us/background.svg"), linear-gradient(309deg, #000000 51%, #771bae);*/
  background-image: linear-gradient(309deg, #000000 51%, #771bae);
  font-size: 20px;
  background-size: cover;
}
.get-app-btn-container {
  padding-bottom: 320px;
}

.btn-hero {
  height: 75px;
  width: 90%;
  max-width: 600px;
  margin: auto;
  font-weight: bold;
  border-radius: 500px;
  cursor: pointer;
  font-size: 25px;
  border: none;
  padding-top: 10px;
  position: relative;
}
.btn-hero-primary, .btn-hero-primary:hover, .btn-hero-primary:focus, .btn-hero-primary:active {
  color: #ffffff;
  background-image: linear-gradient(101deg, #5b9bfb 2%, #00c092 96%) !important;
  padding-top: 10px;
  outline: none;
  border: none;
  transition: 0.3s;
}

.btn-hero-primary:before{
  border-radius: 500px;
  content: '';
  position: absolute;
  top: -6px;
  left: -6px;
  bottom: -6px;
  right: -6px;
  background: linear-gradient(60deg, rgba(65, 126, 170, 0.95), rgba(51, 122, 187, 0.95), rgba(60, 115, 202, 0.95), rgba(88, 104, 211, 0.95), rgba(124, 88, 213, 0.95), rgba(136, 76, 209, 0.95), rgba(149, 61, 203, 0.95), rgba(161, 40, 196, 0.95), rgba(151, 36, 192, 0.95), rgba(140, 32, 188, 0.95), rgba(130, 29, 184, 0.95), rgba(119, 25, 180, 0.95));
  z-index: -1;
  animation: animatedbtngetappgradient 2s ease alternate infinite;
  background-size: 300% 300%;
  -webkit-filter: drop-shadow(0px 0px 35px #fff);
  filter: drop-shadow(0px 0px 35px #fff);
}

@keyframes animatedbtngetappgradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}


.btn-hero-primary:hover {
  color: #751da7 !important;
}

.h1-title {
  font-size: 4rem !important;
}
.medium-title {
  font-size: 2.5rem !important;
}
.youtube-vid{
  max-width: 560px;
  min-height: 315px;
  width: 100%;
  border-radius: 2rem;
  object-fit: unset;
  -webkit-filter: drop-shadow(0px 0px 35px #fff);
  filter: drop-shadow(0px 0px 35px #fff);
}
@media (max-width: 780px) {
  .h1-title {
    font-size: 2rem !important;
  }
  #hero-section {
    min-height: calc(100vh);
    font-size: 16px !important;
  }
  .medium-title {
    font-size: 1.5rem !important;
  }
  .instruction-text{
    font-size: 18px;
    font-weight: normal;
  }
  .instruction-icon{
    height: 45px;
  }

}
@keyframes ld-fall {
  0% { transform: translate(0,0px) rotate3d(1,1,1,0deg); }
  100% { transform: translate(0,969px) rotate3d(1,1,1,1080deg) ; }
}
.ld.ld-fall {
  animation: ld-fall 4s linear infinite;
  animation: ld-fall 1s linear infinite;
}
</style>
